// extracted by mini-css-extract-plugin
export default {"page":"Faq_page__nIt17","faqsBody":"Faq_faqsBody__gGOym","title":"Faq_title__21AHw","addFaq":"Faq_addFaq__+7RxN","button":"Faq_button__YklB0"};